///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.category_assignment = abcsetup.category_assignment || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.category_assignment = {
    init: function() {
        let belongsTo = null;
        let assignTo = null;
        let loginButton = null;

        $(document).on('change', '.assign-to-select', function(e) {
            let button = $(this).parent().closest('tr').find('button');

            if ($(this).val() != 'null') {
                button.attr('disabled', false);
                button.attr('style', 'background-color: #D153E2');
            } else {
                button.attr('disabled', true);
                button.attr('style', 'background-color: #828282');
            }   
        });

        $(document).on('click', '.update-button', function(e) {
            belongsTo = $(this).parent().parent().find('td.belongs_to');
            assignTo = $(this).parent().parent().find('td.assign_to').children(); //get select
            loginButton = $(this).parent().find('a');

            let categoryId = $(this).data('category_id');
            let categoryName = $(this).data('category_name');
            let userName = $(this).parent().parent().find('td.assign_to').children().val();
            let rolesList = $(this).parent().parent().find('td.assign_to').children().find(':selected').data('roles');
            let roles = []; 
            let roleId = null;
            
            rolesList.forEach(role => {
                roles.push({
                    'id': role.id,
                    'name': role.name
                });
            });

            if (roles.length > 1) {
                $('#multiple-cm-role-group').empty();

                roles.forEach(role => {
                    $('#multiple-cm-role-group').append(
                        '<label><div class="input-group">\
                            <div class="input-group-prepend">\
                                <div class="input-group-text">\
                                    <input type="radio" data-id="'+role.id+'" name="multiple-cms-selected-role" />\
                                </div>\
                            </div>\
                            <span class="form-control">'+role.name+'</span>\
                        </div></label><br/>'
                    )
                });

                $('#cm-modal-userName').val(userName);
                $('#cm-modal-categoryId').val(categoryId);
                $('#cm-modal-categoryName').val(categoryName);

                $('#multiple-cm-roles-modal').modal('show')

            } else {
                roleId = roles[0].id
                updateCategory(categoryId, categoryName, userName, roleId);
            }
        });

        $(document).on('click', '#save-multiple-cm-roles-btn', function(e) {
            updateCategory(
                $('#cm-modal-categoryId').val(),
                $('#cm-modal-categoryName').val(),
                $('#cm-modal-userName').val(),
                $('input[name="multiple-cms-selected-role"]:checked').data('id')
            );
        });

        function updateCategory(category, categoryName, userName, roleId) {
            abcsetup.blockUI(true);

            axios.post('/category_assignment/update', {
                'userName': userName,
                'roleId': roleId,
                'categoryId': category,
                'categoryName': categoryName
            })
            .then(response => {
                const data = response.data;

                if (data && data.name && data.message && data.loginRoute) {
                    belongsTo.text(data.name);
                    abcsetup.unblockUI();
                    abcsetup.alerts.show('Success', response.data.message);
                    loginButton.attr('href', data.loginRoute);

                    assignTo.val('null');
                }
            })
            .catch(error => {
                abcsetup.unblockUI();
                console.error(error);
                abcsetup.alerts.show('Error', "Something went wrong, please try again later.");
            });
        }
    },
}